import {Component} from 'react'
import './index.css'

class VisitCountries extends Component {
  constructor(props) {
    super(props)
    this.state = {
      countriesList: props.initialCountries || [],
    }
  }

  handleVisit = countryId => {
    this.setState(prevState => ({
      countriesList: prevState.countriesList.map(country =>
        country.id === countryId
          ? {...country, isVisited: !country.isVisited}
          : country,
      ),
    }))
  }

  render() {
    const {countriesList} = this.state
    const visited = countriesList.filter(each => each.isVisited)
    const {length} = visited

    return (
      <div className="main-container">
        <div className="countries-container">
          <h1 className="countries-heading">Countries</h1>
          <ul>
            {countriesList.map(each => (
              <li key={each.id}>
                <div className="country-item">
                  <p className="country-name">{each.name}</p>
                  {each.isVisited ? (
                    <p className="visited-country-name">Visited</p>
                  ) : (
                    <button
                      type="button"
                      className="country-button"
                      onClick={() => this.handleVisit(each.id)}
                    >
                      Visit
                    </button>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="visited-countries-container">
          <h1 className="countries-heading">Visited Countries</h1>
          {length === 0 ? (
            <p>No Countries Visited Yet</p>
          ) : (
            <ul>
              {visited.map(each => (
                <li key={each.id}>
                  <div className="visited-country-item">
                    <img
                      src={each.imageUrl}
                      alt={`${each.name} thumbnail`}
                      className="visited-country-img"
                    />
                    <div className="visited-country-footer">
                      <p className="visited-country-name">{each.name}</p>
                      <button
                        type="button"
                        className="visited-country-button"
                        onClick={() => this.handleVisit(each.id)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    )
  }
}

export default VisitCountries
